<template>
    <div class="card mb-3">
        <div class="card-body">
            <button class="btn btn-info mr-2" data-toggle="collapse" data-target="#advanced">جستجو پیشرفته</button>
            <div class="collapse fade mt-3" id="advanced">
                <div class="row">
                    <div class="col-md-3">
                        <label>دامنه</label>
                        <Vselect v-model="domainId" :reduce="item => item.domainId" label="title" :options="domains">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>

                    <div class="col-md-3 ">
                        <button class="btn btn-primary mx-2 w-100" style="margin-top:29px" @click="search">
                            <i class="si si-magnifier"></i>
                            جستجو
                        </button>
                        <button class="btn btn-danger" v-on:click="removeFilter" style="margin-top:29px"
                            v-if="isAdvanced">حذف فیلتر</button>

                    </div>
                </div>
            </div>
            <hr class="w-100">
            <router-link  :to="{name: 'organization.create'}" target="_blank"  class="btn btn-primary mb-3">ایجاد سازمان جدید</router-link>
            <Loading v-if="showLoading" />
            <DataTable :columns="columns" :customColumns="customColumns" :rows="rows" v-if="rows.length" :count="count" :url="'Management/organizations/List'" :operations="['organizations',{contracts: {class: 'primary',title: 'قرارداد ها',icon: 'ti-layers'}}]" />
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Organizations',
    data(){
        return {
            showLoading: true,
            customColumns:[
                 {
                    title: 'ارسال با پست',
                    func: function(row){
                        if(row.needDelivery) return "دارد"
                        return "ندارد"
                    }
                },
                {
                    title: 'نوع سازمان',
                    func: function(row){
                        if(row.tourism) return "گردشگری"
                        return "اتباع"
                    }
                },
                {
                    title: 'دسترسی به کد فیدا',
                    func: function(row){
                        if(row.domainMetaData && row.domainMetaData.fidaCode) return "دارد"
                        return "ندارد"
                    }
                },
            ],
            columns: [
                {
                    title: 'نام ',
                    field: 'title',
                },
                {
                    title: 'شناسه دامنه',
                    field: 'domainDataId'
                },
                {
                    title:"تاریخ ایجاد",
                    field: "createdAtShamsi"
                },
                {
                    title:"صادرکننده کارت",
                    field: "cardIssuerTitle"
                },
                {
                    title:"صادرکننده کارت هدیه",
                    field: "giftCardIssuerTitle"
                },
            ],
            shippings: {},
            rows: [],
            count: 0,
            organizations: [],
            domainId :0,
            isAdvanced:false,
            domains: [
                 {domainId: 0, title: "همه"}
            ],
        }
    },
    methods: {
        getData(){
            this.$api.post('Management/organizations/List',{perPage: 10,page: 1 , domainId: this.domainId}).then(({data}) => {
                if(data.status){
                     data.result.list.forEach(item =>{
                       this.rows = [
                        ...this.rows ,
                        {...item ,
                        "createdAtShamsi": item.createdAtShamsi.slice(0,4) + '/' + item.createdAtShamsi.slice(4,6) + '/' + item.createdAtShamsi.slice(6,8)
                        }
                        ]
                    });
                    this.count = data.result.totalCount;
                    this.rows.operations = ['organizations',{update: {class: 'btn-icon text-info',title: 'ویرایش',icon: 'ti-eye'}, target :"_blank"}];
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        search() {
            this.getData();
            this.isAdvanced = true;
        },
         removeFilter() {
            this.isAdvanced = false;
            this.domainId = 0;
            this.getData();
        },
    },
    async created(){
        this.getData();
         this.$api.post('User/GetDomain', {}).then(({ data }) => {
                    this.domains =[ ...this.domains, ...data.result];
                }).finally(() => {
                    this.showLoading = false;
                });
    }
}
</script>